const serviceIcons = {
  serviceIcon1: require("../Assets/Images/ServiceIcons/camera.svg"),
  serviceIcon2: require("../Assets/Images/ServiceIcons/edit.svg"),
  serviceIcon3: require("../Assets/Images/ServiceIcons/profile.svg"),
  serviceIcon4: require("../Assets/Images/ServiceIcons/video.svg")
};

export default serviceIcons;
